import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const Content = styled(Typography)(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['xxxs'])};
`,
);
